import { render, staticRenderFns } from "./InventoryComponent.vue?vue&type=template&id=65cf1c56&"
import script from "./InventoryComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports